module.exports = __webpack_public_path__ + "03_long_brown.509ce11f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_long_brown.png
// module id = UbCo
// module chunks = 0